import { render, staticRenderFns } from "./CameraCapture.vue?vue&type=template&id=87836c7e&scoped=true"
import script from "./CameraCapture.vue?vue&type=script&lang=js"
export * from "./CameraCapture.vue?vue&type=script&lang=js"
import style0 from "./CameraCapture.vue?vue&type=style&index=0&id=87836c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87836c7e",
  null
  
)

export default component.exports